// const base="http://localhost/gtadmin/api/"
// const login="http://localhost/gtacademy/login"
const login="https://control.globaltutorsacademy.com/login";
const base="https://control.globaltutorsacademy.com/api/";
export const urls = {
    base:base,
    dashboard:base+"dashboardHandler",
    profile:base+"profileHandler",
    login:login,
    logout:base+"logout",
    academic:base+"academicHandler",
    teachers:base+"teachersHandler",
    subject:base+"subjectHandler",
    students:base+"studentHandler",
    test:base+"testHandler",
    quiz:base+"quizHandler",
    student:base+"studentHandler",
    upload:base+"upload.php"
};